import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

import { Box, Grid, Button, Container, Card } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import _ from "lodash";
import { useNavigate } from "react-router-dom";

const bgImage = require("../../assets/images/Webbie_default_banner.jpg");
function BannerCarousel({ type }) {
  // Read from localStorage
  const localData = localStorage.getItem("websiteDetails");
  const parseData = localData ? JSON.parse(localData) : null;
  const navigate = useNavigate();

  // const hostname = "mclardies";
  const hostname = window.location.hostname;
  // console.log('hostname', hostname)
  // alert('hostname', `${window.location}`)
  // Mapping of domains to their specific public folder banners
  // [USER NOTE: Add your domain -> banner mappings here]
  // Update: We now use arrays for values to support multiple banners per domain
  const publicInjectionMap = {
    "alora": ["/Alora Medical.png"],
    "mclardies": ["/mclardies_banner.png"],
    "saou": ["/SAOU !st Banner.png", "/SAOU 2nd Banner.png"],
    "broadacressyringa": ["/Khula Cafe - Syringa.png"],
    "broadacressyringa1": ["/Khula Cafe - Syringa.png"],
    "broadacreschartwell": ["/Khula Cafe Chartwell & Waterford.png"],
    "khulacafewaterford": ["/Khula Cafe Chartwell & Waterford.png"],
    "khulacafewaterfordpos": ["/Khula Cafe Chartwell & Waterford.png"],
    "broadacreschartwell1": ["/Khula Cafe Chartwell & Waterford.png"],
    "broadacreschartwell2": ["/Khula Cafe Chartwell & Waterford.png"],
    "broadacreschartwell3": ["/Khula Cafe Chartwell & Waterford.png"],
    "curroauroratuckshop": ["/jem_curro_banner.png"],
    "localhost": ["/jem_curro_banner.png"],
  };

  const matchedDomain = Object.keys(publicInjectionMap).find((domain) =>
    hostname.includes(domain),
  );

  // This will be an array of banners
  const publicBanners = matchedDomain ? publicInjectionMap[matchedDomain] : [];

  let bannerSlides = Array.isArray(parseData?.banner)
    ? [...parseData.banner]
    : [];

  // // Filter based on page type if specified
  // if (type === "contact" || type === "about") {
  //   bannerSlides = bannerSlides.slice(0, 1);
  // }

  // Inject dynamic public folders images if matched
  if (publicBanners.length > 0) {
    publicBanners.forEach((banner) => {
      if (!bannerSlides.includes(banner)) {
        bannerSlides.push(banner);
      }
    });
  }

  // Ensure at least 2 images for desktop slidesPerView={2}
  // If we still only have 1 image, we add a fallback or duplicate to keep UI consistent
  if (bannerSlides.length < 2) {
    const fallback = publicBanners.length > 0 ? publicBanners[0] : bgImage;
    if (!bannerSlides.includes(fallback)) {
      bannerSlides.push(fallback);
    }
    // If still only 1 (case where initial slide WAS the fallback), duplicate it
    if (bannerSlides.length === 1) {
      bannerSlides.push(bannerSlides[0]);
    }
  }

  // Final fallback for empty cases
  const slides =
    bannerSlides.length > 0 ? bannerSlides : [bgImage, "/jem_curro_banner.png"];

  console.log("slides", slides, parseData?.banner);
  return (
    <>
      {/* ----------------------- DESKTOP VERSION ----------------------- */}
      <Container maxWidth="lg" sx={{ px: { xs: 1.5, sm: 2 } }}>
        <Box
          sx={{
            display: { xs: "none", sm: "block" },
            maxWidth: "1250px",
            width: "100%",
            margin: "0 auto",
            mt: { xs: "56px", sm: "90px", md: "90px" },
            borderRadius: "12px",
            overflow: "hidden",

            height: "clamp(200px, 25vw, 320px)",
            maxHeight: "320px",
          }}
        >
          <Swiper
            style={{ width: "100%", height: "100%" }}
            modules={[Autoplay]}
            slidesPerView={2}
            autoplay={{ delay: 3000 }}
            loop
          >
            {slides.map((img, index) => (
              <SwiperSlide key={index}>
                <Card sx={{
                  position: "relative",

                  "&::after": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "-100%",
                    width: "100%",
                    height: "100%",
                    // background:
                    //   "linear-gradient(120deg, transparent, rgba(255,255,255,0.4), transparent)",
                    // transition: "all 0.6s",
                  },

                  "&:hover::after": {
                    left: "100%",
                  },
                  width: "95%",
                  margin: "0 auto",
                  borderRadius: "1rem",
                  boxshadow: "0 4px 8px rgba(0,0,0,0.9)",
                  height: "100%",
                  display: "flex",
                }}>
                  <img
                    src={img}
                    alt="banner"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "fill", // ✅ NO STRETCH
                      objectPosition: "center",
                      display: "block",
                    }}
                  />
                </Card>
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      </Container>
      {/* ----------------------- MOBILE VERSION ----------------------- */}
      <Container
        maxWidth={false}
        sx={{
          px: { xs: 1.5, sm: 2 },
          display: { xs: "block", sm: "none" }, // ✅ only mobile
        }}
      >
        <Box
          sx={{
            width: "100%",
            margin: "0 auto",
            mt: "8rem",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          <Swiper
            modules={[Autoplay]}
            slidesPerView={1}
            navigation
            autoplay={{ delay: 3000 }}
            loop
          >
            {slides?.map((img, index) => (
              <SwiperSlide key={index}>
                <Card sx={{
                  position: "relative",

                  "&::after": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "-100%",
                    width: "100%",
                    height: "100%",
                    // background:
                    //   "linear-gradient(120deg, transparent, rgba(255,255,255,0.1), transparent)",
                    // transition: "all 0.6s",
                  },

                  "&:hover::after": {
                    left: "100%",
                  },
                  width: "95%",
                  margin: "0 auto",
                  borderRadius: "1rem",
                  height: "100%",
                  display: "flex",
                }}>
                  <img
                    src={img}
                    alt="banner"
                    style={{
                      width: "100%",
                      height: "clamp(160px, 30vw, 200px)",
                      objectFit: "fill",
                      objectPosition: "center",
                      display: "block",
                    }}
                  />
                </Card>
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      </Container>
    </>
  );
}

export default BannerCarousel;
